/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchType } from '../models/BranchType';
import type { CheckBoxDto } from '../models/CheckBoxDto';
import type { CheckBoxInstanceInput } from '../models/CheckBoxInstanceInput';
import type { CheckBoxInstanceLabourDto } from '../models/CheckBoxInstanceLabourDto';
import type { CheckBoxInstanceLabourUpdateInput } from '../models/CheckBoxInstanceLabourUpdateInput';
import type { CheckBoxInstancePartInput } from '../models/CheckBoxInstancePartInput';
import type { CheckBoxInstancePartUpdateInput } from '../models/CheckBoxInstancePartUpdateInput';
import type { CheckBoxInstanceUpdateStatusInput } from '../models/CheckBoxInstanceUpdateStatusInput';
import type { CheckInCommentDto } from '../models/CheckInCommentDto';
import type { CheckInstanceType } from '../models/CheckInstanceType';
import type { CheckListDto } from '../models/CheckListDto';
import type { Int32_StringValueTuple } from '../models/Int32_StringValueTuple';
import type { PreparationSummaryModel } from '../models/PreparationSummaryModel';
import type { UsedVehiclePreparationLookupModel } from '../models/UsedVehiclePreparationLookupModel';
import type { UserNotificationType } from '../models/UserNotificationType';
import type { VehiclePreparationCheckBoxes } from '../models/VehiclePreparationCheckBoxes';
import type { VehiclePreparationCheckTableRespPagedListData } from '../models/VehiclePreparationCheckTableRespPagedListData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VehiclePreparationCheckService {

  /**
   * @param isCompleted 
   * @param isUsed 
   * @param from 
   * @param to 
   * @param branchId
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param regNo 
   * @param paginationSkipPagination Пропустить пагинацию
   * @param paginationPage Страница
   * @param paginationMaxCount Максимально количество записей на странице
   * @returns VehiclePreparationCheckTableRespPagedListData Success
   * @throws ApiError
   */
  public static getVehiclePreparationChecklists(
isCompleted?: boolean,
isUsed?: boolean,
from?: string,
to?: string,
branchId?: BranchType,
regNo?: string,
paginationSkipPagination?: boolean,
paginationPage?: number,
paginationMaxCount?: number,
): CancelablePromise<VehiclePreparationCheckTableRespPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicle-preparation/checklists',
      query: {
        'IsCompleted': isCompleted,
        'IsUsed': isUsed,
        'From': from,
        'To': to,
        'BranchId': branchId,
        'RegNo': regNo,
        'Pagination.SkipPagination': paginationSkipPagination,
        'Pagination.Page': paginationPage,
        'Pagination.MaxCount': paginationMaxCount,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param wip 
   * @param branchId
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @returns UsedVehiclePreparationLookupModel Success
   * @throws ApiError
   */
  public static getVehiclePreparationChecklistsWipLookup(
wip?: number,
branchId?: BranchType,
): CancelablePromise<UsedVehiclePreparationLookupModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicle-preparation/checklists/wip-lookup',
      query: {
        'wip': wip,
        'branchId': branchId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns number Created
   * @throws ApiError
   */
  public static postVehiclePreparationChecklists(
soHeaderId: number,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-preparation/checklists/{soHeaderId}',
      path: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns CheckListDto Success
   * @throws ApiError
   */
  public static getVehiclePreparationChecklists1(
id: number,
): CancelablePromise<CheckListDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicle-preparation/checklists/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @param cbId 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putVehiclePreparationChecklistsCheckboxes(
clId: number,
cbId: number,
requestBody?: CheckBoxInstanceInput,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbId}',
      path: {
        'clId': clId,
        'cbId': cbId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param checklistId 
   * @param groupInputInstanceId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static putVehiclePreparationChecklistsInputs(
checklistId: number,
groupInputInstanceId: number,
requestBody?: string,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vehicle-preparation/checklists/{checklistId}/inputs/{groupInputInstanceId}',
      path: {
        'checklistId': checklistId,
        'groupInputInstanceId': groupInputInstanceId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param instanceType
 *
 * 0 = CheckBox
 *
 * 1 = GroupInput
   * @param instanceId 
   * @param formData 
   * @returns Int32_StringValueTuple Created
   * @throws ApiError
   */
  public static postVehiclePreparationChecklistsMedia(
id: number,
instanceType: CheckInstanceType,
instanceId: number,
formData?: {
file?: Blob;
},
): CancelablePromise<Int32_StringValueTuple> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-preparation/checklists/{id}/{instanceType}/{instanceId}/media',
      path: {
        'id': id,
        'instanceType': instanceType,
        'instanceId': instanceId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param mId 
   * @param clId 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteVehiclePreparationChecklistsMedia(
mId: number,
clId: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vehicle-preparation/checklists/{clId}/media/{mId}',
      path: {
        'mId': mId,
        'clId': clId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @param cbId 
   * @param lId 
   * @returns CheckBoxInstanceLabourDto Success
   * @throws ApiError
   */
  public static getVehiclePreparationChecklistsCheckboxesLabour(
clId: number,
cbId: number,
lId: number,
): CancelablePromise<CheckBoxInstanceLabourDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbId}/labour/{lId}',
      path: {
        'clId': clId,
        'cbId': cbId,
        'lId': lId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @param cbId 
   * @param lId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static putVehiclePreparationChecklistsCheckboxesLabour(
clId: number,
cbId: number,
lId: number,
requestBody?: CheckBoxInstanceLabourUpdateInput,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbId}/labour/{lId}',
      path: {
        'clId': clId,
        'cbId': cbId,
        'lId': lId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @param cbId 
   * @param lId 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteVehiclePreparationChecklistsCheckboxesLabour(
clId: number,
cbId: number,
lId: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbId}/labour/{lId}',
      path: {
        'clId': clId,
        'cbId': cbId,
        'lId': lId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @param cbId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postVehiclePreparationChecklistsCheckboxesLabour(
clId: number,
cbId: number,
requestBody?: CheckBoxInstanceLabourUpdateInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbId}/labour',
      path: {
        'clId': clId,
        'cbId': cbId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @param cbiId 
   * @param lId 
   * @returns void 
   * @throws ApiError
   */
  public static deleteVehiclePreparationChecklistsCheckboxesLabourSoftDelete(
clId: number,
cbiId: number,
lId: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbiId}/labour/{lId}/soft-delete',
      path: {
        'clId': clId,
        'cbiId': cbiId,
        'lId': lId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @param cbiId 
   * @param lId 
   * @returns void 
   * @throws ApiError
   */
  public static postVehiclePreparationChecklistsCheckboxesLabourRestore(
clId: number,
cbiId: number,
lId: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbiId}/labour/{lId}/restore',
      path: {
        'clId': clId,
        'cbiId': cbiId,
        'lId': lId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @param cbiId 
   * @returns number Created
   * @throws ApiError
   */
  public static postVehiclePreparationChecklistsCheckboxesPartRequest(
clId: number,
cbiId: number,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbiId}/part-request',
      path: {
        'clId': clId,
        'cbiId': cbiId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @param cbId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postVehiclePreparationChecklistsCheckboxesPart(
clId: number,
cbId: number,
requestBody?: CheckBoxInstancePartInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbId}/part',
      path: {
        'clId': clId,
        'cbId': cbId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @param cbId 
   * @param pId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static putVehiclePreparationChecklistsCheckboxesParts(
clId: number,
cbId: number,
pId: number,
requestBody?: CheckBoxInstancePartUpdateInput,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbId}/parts/{pId}',
      path: {
        'clId': clId,
        'cbId': cbId,
        'pId': pId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @param pId 
   * @param cbId 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteVehiclePreparationChecklistsCheckboxesPart(
clId: number,
pId: number,
cbId: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbId}/part/{pId}',
      path: {
        'clId': clId,
        'pId': pId,
        'cbId': cbId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @param cbiId 
   * @param pId 
   * @returns void 
   * @throws ApiError
   */
  public static deleteVehiclePreparationChecklistsCheckboxesPartSoftDelete(
clId: number,
cbiId: number,
pId: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbiId}/part/{pId}/soft-delete',
      path: {
        'clId': clId,
        'cbiId': cbiId,
        'pId': pId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @param cbiId 
   * @param pId 
   * @returns void 
   * @throws ApiError
   */
  public static postVehiclePreparationChecklistsCheckboxesPartRestore(
clId: number,
cbiId: number,
pId: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbiId}/part/{pId}/restore',
      path: {
        'clId': clId,
        'cbiId': cbiId,
        'pId': pId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param checkListId 
   * @returns PreparationSummaryModel Success
   * @throws ApiError
   */
  public static getVehiclePreparationChecklistReportSummary(
checkListId?: number,
): CancelablePromise<PreparationSummaryModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicle-preparation/checklist/report-summary',
      query: {
        'checkListId': checkListId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param checkListId 
   * @returns CheckBoxDto Success
   * @throws ApiError
   */
  public static getVehiclePreparationChecklistRepairOrder(
checkListId?: number,
): CancelablePromise<Array<CheckBoxDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicle-preparation/checklist/repair-order',
      query: {
        'checkListId': checkListId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param checkListId 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postVehiclePreparationChecklistComplete(
checkListId?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-preparation/checklist/complete',
      query: {
        'checkListId': checkListId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @param cbiId 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putVehiclePreparationChecklistsCheckboxesStatus(
clId: number,
cbiId: number,
requestBody?: CheckBoxInstanceUpdateStatusInput,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbiId}/status',
      path: {
        'clId': clId,
        'cbiId': cbiId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @param cbiId 
   * @returns void 
   * @throws ApiError
   */
  public static postVehiclePreparationChecklistsCheckboxesCdk(
clId: number,
cbiId: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbiId}/cdk',
      path: {
        'clId': clId,
        'cbiId': cbiId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @param type
 *
 * 0 = Parts
 *
 * 1 = Authorisation
 *
 * 2 = Authorized
   * @returns void 
   * @throws ApiError
   */
  public static postVehiclePreparationChecklistsNotifications(
clId: number,
type: UserNotificationType,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-preparation/checklists/{clId}/notifications/{type}',
      path: {
        'clId': clId,
        'type': type,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @returns CheckInCommentDto Success
   * @throws ApiError
   */
  public static getVehiclePreparationChecklistsNotes(
clId: number,
): CancelablePromise<Array<CheckInCommentDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicle-preparation/checklists/{clId}/notes',
      path: {
        'clId': clId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static postVehiclePreparationChecklistsNotes(
clId: number,
requestBody?: string,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-preparation/checklists/{clId}/notes',
      path: {
        'clId': clId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @param cbId 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putVehiclePreparationChecklistsCheckboxesDescription(
clId: number,
cbId: number,
requestBody?: string,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbId}/description',
      path: {
        'clId': clId,
        'cbId': cbId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @returns VehiclePreparationCheckBoxes Success
   * @throws ApiError
   */
  public static getVehiclePreparationChecklistsGetCheckListForVehiclePreparation(
clId: number,
): CancelablePromise<VehiclePreparationCheckBoxes> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicle-preparation/checklists/{clId}/get-check-list-for-vehicle-preparation',
      path: {
        'clId': clId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

}
